import { render, staticRenderFns } from "./VoteSlide.vue?vue&type=template&id=211868ce"
import script from "./VoteSlide.vue?vue&type=script&lang=js"
export * from "./VoteSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('211868ce')) {
      api.createRecord('211868ce', component.options)
    } else {
      api.reload('211868ce', component.options)
    }
    module.hot.accept("./VoteSlide.vue?vue&type=template&id=211868ce", function () {
      api.rerender('211868ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/VoteSlide.vue"
export default component.exports